import { Box, Typography } from "@mui/material"
import React from "react"

export function PatchNote3_1(): React.JSX.Element {
  return (
    <>
      <Typography variant="body1" gutterBottom>
        🎉 Les nouveautés de la{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          version 3.1
        </Box>
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        • Export des{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          résultats directement importables dans Pleiades
        </Box>
        , intégrant toutes les données environnementales de votre estimation shot. À retrouver dans le tableau de bord des
        résultats.
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }} color="">
        • Intégration de la{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          visualisation des Maquettes Beem dans le tableau de comparaison des estimations.
        </Box>
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }} color="">
        • Intégration de{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          nouveaux macro composants
        </Box>{" "}
        pour les{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          murs donnant sur l'extérieur
        </Box>
        .
      </Typography>
    </>
  )
}
